import {GroupedList} from '@wandb/weave/common/util/data';

import {Tile, TilePagination} from './types';

export function getPaginatedTiles(
  tiles: GroupedList<Tile>,
  pagination: TilePagination | null
): GroupedList<Tile> {
  if (pagination == null) {
    return tiles;
  }
  const {start, size} = pagination;
  return tiles.slice(start, start + size);
}
